// extracted by mini-css-extract-plugin
export var text = "_44-0";